module.exports = __webpack_public_path__ + "img/progress-bg.8de87355.svg";